import { useIntl } from 'react-intl'
import styled from 'styled-components'
import { rem } from 'polished'
import BodyText from 'LuxKit/Typography/BodyText'
import Badge from 'LuxKit/Badge'
import FormatCurrency from 'components/Common/FormatCurrency'
import LineShoppingCartIcon from 'LuxKit/Icons/line/LineShoppingCartIcon'
import NavBarButton from 'components/NavKit/NavBarButton/NavBarButton'
import TextLoadingBox from 'LuxKit/Typography/TextLoadingBox'
import Group from 'components/utils/Group'
import srOnly from 'styles/tools/sr-only'

interface Props {
  itemCount: number
  totalPrice: number
  isLoading: boolean
  onClick: () => void
}

const StyledCartButton = styled(NavBarButton)`
  height: ${rem(38)};
  padding: ${rem(4)} ${rem(8)};
  border-radius: ${props => props.theme.borderRadius.round};
  border: 0;
  background-color: ${props => props.theme.palette.neutral.surface.normalBackground};
`

const CartIconWrapper = styled.span`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: ${rem(30)};
  height: ${rem(30)};
`

const ItemCountBadge = styled(Badge)`
  position: absolute;
  top: ${rem(-4)};
  right: ${rem(-4)};
  transform: scale(0.8203125);
  transform-origin: top right;
`

const HiddenLabel = styled.span`
  ${srOnly}
`

function CartButton({ itemCount, totalPrice, isLoading, onClick }: Props) {
  const intl = useIntl()

  const tripCartLabel = intl.formatMessage({
    id: '9ldY3Yc7FjrKlzu4hrig',
    defaultMessage: 'Trip cart',
    description: 'Label for the cart button in the trip planner header that opens the trip cart panel',
  })

  return (
    <StyledCartButton
      onClick={onClick}
    >
      <Group direction="horizontal" gap={8} horizontalAlign="center" verticalAlign="center">
        <HiddenLabel>{tripCartLabel}</HiddenLabel>
        <CartIconWrapper>
          <LineShoppingCartIcon size={18.75} />
          {!isLoading && <ItemCountBadge kind="string" mode="critical">{String(itemCount)}</ItemCountBadge>}
        </CartIconWrapper>
        {isLoading && <TextLoadingBox typography="body-medium" width="10ch" />}
        {!isLoading && (
          <BodyText variant="medium" weight="bold">
            <FormatCurrency value={totalPrice} format="roundedDollar" />
          </BodyText>
        )}
      </Group>
    </StyledCartButton>
  )
}

export default CartButton
